import { getHowToCategoryPalette, formatVideoCount } from './howToCategoryPalette.js';

export function HowToCategoryHeader({ categoryKey, title, videoCount, isFirst = false }) {
  const palette = getHowToCategoryPalette(categoryKey);

  return (
    <div class={`how-to-cat${isFirst ? ' how-to-cat--first' : ''}`}>
      <div
        class="how-to-cat__card"
        style={{
          background: `linear-gradient(105deg, ${palette.gradientStart} 0%, ${palette.gradientEnd} 100%)`,
        }}
      >
        <span class="how-to-cat__glow" style={{ backgroundColor: palette.gradientGlow }} aria-hidden="true" />
        <div class="how-to-cat__row">
          <span class="how-to-cat__bar" style={{ backgroundColor: palette.accentBar }} aria-hidden="true" />
          <span class="how-to-cat__icon" style={{ backgroundColor: palette.iconBg, color: palette.iconColor }}>
            <i class="fas fa-layer-group" aria-hidden="true" />
          </span>
          <h2 class="how-to-cat__title" style={{ color: palette.title }}>
            {title}
          </h2>
          {videoCount > 0 ? (
            <span
              class="how-to-cat__badge"
              style={{
                backgroundColor: palette.badgeBg,
                color: palette.badgeText,
                borderColor: palette.badgeBorder,
              }}
            >
              {formatVideoCount(videoCount)}
            </span>
          ) : null}
        </div>
      </div>
      <div class="how-to-cat__divider" style={{ backgroundColor: palette.divider }} aria-hidden="true" />
    </div>
  );
}
